import * as React from 'react'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import EditOutlined from '@mui/icons-material/EditOutlined'
import DeleteOutline from '@mui/icons-material/DeleteOutline'

type Props = {
  /** Markers (NAD/ECD) are close-only; only activities show Edit/Delete. */
  showEditDelete: boolean
  onClose: () => void
  // SH-1432: edit/delete handlers + server-derived per-event permission gates.
  // REQ-9 is owner-only *visibility* — a control with no permission is not
  // rendered at all (AC-9.1), not merely disabled. Close is always present.
  onEdit?: () => void
  onDelete?: () => void
  canEdit?: boolean
  canDelete?: boolean
}

/**
 * The popover's top action row. For activities, Edit/Delete render only when the
 * event's server-derived permissions allow it (SH-1432 REQ-1/REQ-9); Close is
 * always active.
 */
export function PopoverActions({
  showEditDelete,
  onClose,
  onEdit,
  onDelete,
  canEdit = false,
  canDelete = false,
}: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '2px',
        padding: '8px 8px 0',
      }}
    >
      {showEditDelete && canEdit && onEdit && (
        <IconButton
          aria-label="Edit event"
          size="small"
          onClick={onEdit}
          data-test-id="event-detail-edit"
        >
          <EditOutlined fontSize="small" />
        </IconButton>
      )}
      {showEditDelete && canDelete && onDelete && (
        <IconButton
          aria-label="Delete event"
          size="small"
          onClick={onDelete}
          data-test-id="event-detail-delete"
        >
          <DeleteOutline fontSize="small" />
        </IconButton>
      )}
      <IconButton
        aria-label="Close"
        size="small"
        onClick={onClose}
        data-test-id="event-detail-close"
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  )
}
